import React from 'react';
import { FormSummary } from '@alinta-digital/asg';
import { SummaryProps } from '../../types';
import { FormContainerContext } from '../../contexts/FormContainerContext';
import { resetFormContextError, getMonthName } from '../../utils/utils';
import { SummaryContent } from '../SummaryContent';

interface DebitDetailsSummaryProps extends SummaryProps {
  accountNumber: string;
  dateOfBirth: string;
  firstName: string;
  lastName: string;
}

export const IdentificationSummary: React.FC<DebitDetailsSummaryProps> = ({
  accountNumber,
  dateOfBirth,
  firstName,
  lastName,
  onEditClick,
  showSummaryFields,
}) => {
  const dob = dateOfBirth.split('/');
  const {
    values: formContextValues,
    dispatch: formContextDispatch,
  } = React.useContext(FormContainerContext);

  return (
    <FormSummary
      heading="Step 1: Your account"
      body={
        showSummaryFields ? (
          <SummaryContent
            leftItems={[
              {
                label: {
                  value: 'Electricity or gas reference number',
                  dataTestId: 'summary_accountNumber_label',
                },
                content: {
                  value: accountNumber,
                  dataTestId: 'summary_accountNumber_content',
                },
              },
              {
                label: {
                  value: 'Primary contact details',
                  dataTestId: 'summary_contactDetails_label',
                },
                content: {
                  value: `${firstName} ${lastName}`,
                  dataTestId: 'summary_contactDetails_content',
                },
              },
            ]}
            rightItems={[
              {
                label: {
                  value: 'Date of birth',
                  dataTestId: 'summary_dob_label',
                },
                content: {
                  value: `${parseInt(dob[0])} ${getMonthName(dob[1])} ${
                    dob[2]
                  }`,
                  dataTestId: 'summary_dob_content',
                },
              },
            ]}
          />
        ) : (
          undefined
        )
      }
      onEditClick={
        showSummaryFields
          ? () => {
              resetFormContextError(formContextValues, formContextDispatch, 1);
              onEditClick();
            }
          : undefined
      }
    />
  );
};
